import { motion } from "framer-motion";
import Layout from "@/components/Layout";
import SEO from "@/components/SEO";
import PageHero from "@/components/PageHero";
import servicesHero from "@/assets/services-hero.jpg";
import EmailDisclaimerDialog from "@/components/EmailDisclaimerDialog";

const JOBS_URL = "https://www.theapplicantmanager.com/careers?co=vm";

const JoinUsPage = () => {
  return (
    <Layout>
      <SEO title="Careers | Vaughan McLean" description="Join the Vaughan McLean team. Explore career opportunities at a growing litigation and advisory law firm with offices nationwide." />
      <PageHero backgroundImage={servicesHero} title="Join Us" subtitle="Careers" />

      <section className="section-dark py-24">
        <div className="container mx-auto px-8 lg:px-16">
          <div className="max-w-3xl">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
              viewport={{ once: true }}
            >
              <h2 className="font-heading text-4xl font-light text-foreground mb-6">
                Build Your Career With Us
              </h2>
              <p className="text-muted-foreground font-body leading-relaxed mb-8">
                We are always looking for talented, driven professionals who share our commitment
                to excellence. Our firm offers a collaborative environment, meaningful work, and
                the opportunity to grow alongside some of the best legal minds in the industry.
              </p>
              <p className="text-muted-foreground font-body leading-relaxed">
                Interested in joining our team? We'd love to hear from you.
              </p>
              <p className="text-muted-foreground font-body leading-relaxed mt-8">
                Please{" "}
                <a
                  href={JOBS_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-primary hover:underline transition-colors"
                >
                  click here
                </a>{" "}
                to see open positions.
              </p>
              <p className="text-muted-foreground font-body leading-relaxed mt-8">
                Or send your résumé to{" "}
                <EmailDisclaimerDialog
                  email="careers@vaughanmclean.com"
                  attorneyName="Vaughan McLean Careers"
                  variant="inline"
                />{" "}
                and a member of our team will be in touch.
              </p>
              <p className="text-muted-foreground font-body leading-relaxed mt-8">
                Want to learn more about us? Visit our{" "}
                <a
                  href="https://www.linkedin.com/company/vaughan-mclean/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-primary hover:underline transition-colors"
                >
                  LinkedIn page
                </a>{" "}
                to stay up to date on firm news, insights, and career opportunities.
              </p>
            </motion.div>
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default JoinUsPage;
